import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class InlineLink extends Component {
  render() {
    const finalRootClass = classnames(style.root, this.props.rootClassname);
    return (
      <Link to={this.props.to} className={finalRootClass}>
        {this.props.children}
      </Link>
    );
  }
}

InlineLink.propTypes = {
  rootClassname: PropTypes.string,
  to: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/InlineLink/index.js